module.exports = __webpack_public_path__ + "img/brands.18364216.png";